import { Controller } from "@hotwired/stimulus"

// Toggles all card_ids[] checkboxes between select-all and unselect-all.
export default class extends Controller {
  static targets = ["checkbox", "button"]

  toggle() {
    const selectAll = !this.#allSelected()
    this.checkboxTargets.forEach((box) => {
      box.checked = selectAll
    })
    this.#syncLabel()
  }

  sync() {
    this.#syncLabel()
  }

  #allSelected() {
    return (
      this.checkboxTargets.length > 0 &&
      this.checkboxTargets.every((box) => box.checked)
    )
  }

  #syncLabel() {
    if (!this.hasButtonTarget) return
    this.buttonTarget.textContent = this.#allSelected() ? "Unselect all" : "Select all"
  }
}
